import HostedInstallInstructions from '../../../components/hosted/InstallInstructions';
import { type AppInstallPageProps } from '../../types';

/**
 * HostedDesktopAppInstallPage — Shows QR code + app store badges for scanning.
 *
 * Standalone page (no sidebar/layout shell needed, this is a direct-link entry).
 */
export default function HostedDesktopAppInstallPage({
  appName,
}: AppInstallPageProps) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6 font-inter">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        <HostedInstallInstructions
          appName={appName}
          displayName={appName || 'your identity app'}
        />
      </div>
    </div>
  );
}
